import { render } from "./RelatorioTempo.vue?vue&type=template&id=4b3cc3b4&scoped=true"
import script from "./RelatorioTempo.vue?vue&type=script&lang=js"
export * from "./RelatorioTempo.vue?vue&type=script&lang=js"

import "./RelatorioTempo.vue?vue&type=style&index=0&id=4b3cc3b4&scoped=true&lang=css"

import exportComponent from "D:\\FOP\\AGAPE\\AGAPE_HOSPITALAR\\ReguaHospitalar\\frontpainel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b3cc3b4"]])

export default __exports__